import React from "react";

const TextField = (props) => {
  const {
    register,
    label,
    name,
    id,
    placeholder,
    errors,
    maxlength,
    size,
    autocomplete,
    onChange,
    onBlur,
    tabIndex,
    disabled,
    className,
    children,
    hidden,
    registerOptions,
  } = props;

  return (
    <div
      className={`${className} ${
        hidden ? "hidden" : ""
      } checkout-form__field checkout-form__${name} ${
        errors[name] !== undefined ? " has-errors" : ""
      } ${size ? size : ""}`}
    >
      <label>
        {label}
        <input
          type="text"
          name={name}
          maxLength={maxlength}
          placeholder={placeholder}
          onChange={onChange}
          {...register(name, registerOptions)}
          onBlur={onBlur}
          autoComplete={autocomplete}
          id={id}
          tabIndex={tabIndex}
          disabled={disabled}
        />
        {errors[name] && errors[name].type === "required" && (
          <span
            role="alert"
            className="help-tip help-tip--top-left help-tip--form-field"
          >
            Required field
          </span>
        )}
        {errors[name] && errors[name].type === "maxLength" && (
          <span
            role="alert"
            className="help-tip help-tip--top-left help-tip--form-field"
          >
            Maximum length exceeded
          </span>
        )}
        {errors[name] && errors[name].type === "pattern" && (
          <span
            role="alert"
            className="help-tip help-tip--top-left help-tip--form-field"
          >
            {errors[name].message ||
              `Entered value does not match email format`}
          </span>
        )}
        {children}
      </label>
    </div>
  );
};

export default TextField;
